export const mainOptions = [
  // {
  //   id: 4,
  //   label: "Dashboard",
  //   url: "/dashboard",
  //   inactiveIcon: require("../../assets/svgs/dashboard-white.svg").default,
  //   activeIcon: require("../../assets/svgs/dashboard-white.svg").default,
  // },
  {
    id: 1,
    label: 'Sellers Requests',
    url: '/sellers-requests',
    inactiveIcon: require('../../assets/svgs/request-white.svg').default,
    activeIcon: require('../../assets/svgs/request-white.svg').default,
  },
  {
    id: 2,
    label: 'Sellers List',
    url: '/sellers-list',
    inactiveIcon: require('../../assets/svgs/list-inactive.svg').default,
    activeIcon: require('../../assets/svgs/list.svg').default,
  },
  {
    id: 3,
    label: 'Product Transactions',
    url: '/transactions',
    inactiveIcon: require('../../assets/svgs/credit-card-down.svg').default,
    activeIcon: require('../../assets/svgs/credit-card-down.svg').default,
  },

  {
    id: 4,
    label: 'Payments',
    url: '/payments',
    inactiveIcon: require('../../assets/svgs/payments-white.svg').default,
    activeIcon: require('../../assets/svgs/payments-white.svg').default,
  },
  {
    id: 5,
    label: 'Users Management',
    url: '/users',
    inactiveIcon: require('../../assets/svgs/book-white.svg').default,
    activeIcon: require('../../assets/svgs/book-white.svg').default,
  },
];

export const otherOptions = [
  // {
  //   id: 4,
  //   isLinkGroup: true,
  //   label: "Bags",
  //   icon: require("../../assets/svgs/sendbag-white.svg").default,
  //   sublinks: [
  //     {
  //       id: 1,
  //       label: "Request Bags",
  //       url: "/request-a-bag",
  //       inactiveIcon: require("../../assets/svgs/box.svg").default,
  //       activeIcon: require("../../assets/svgs/box.svg").default,
  //     },
  //     {
  //       id: 2,
  //       label: "Send Bags",
  //       url: "/send-a-bag",
  //       inactiveIcon: require("../../assets/svgs/truck.svg").default,
  //       activeIcon: require("../../assets/svgs/truck.svg").default,
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   label: "Menu 4",
  //   url: "/drop-off-locations",
  //   inactiveIcon: require("../../assets/svgs/shopping-cart.svg").default,
  //   activeIcon: require("../../assets/svgs/shopping-cart.svg").default,
  // },
  // {
  //   id: 7,
  //   label: "Menu 5",
  //   url: "/items-to-be-returned",
  //   inactiveIcon: require("../../assets/svgs/shopping-cart.svg").default,
  //   activeIcon: require("../../assets/svgs/shopping-cart.svg").default,
  // },
  // {
  //   id: 8,
  //   label: "Menu 6",
  //   url: "/items-donated-to-charity",
  //   inactiveIcon: require("../../assets/svgs/heart-hand.svg").default,
  //   activeIcon: require("../../assets/svgs/heart-hand.svg").default,
  // },
  // {
  //   id: 8,
  //   label: "Menu 7",
  //   url: "/items-donated-to-charity",
  //   inactiveIcon: require("../../assets/svgs/heart-hand.svg").default,
  //   activeIcon: require("../../assets/svgs/heart-hand.svg").default,
  // },
];

export const accountOptions = [
  {
    id: 8,
    label: "Profile",
    url: "/profile",
    inactiveIcon: require("../../assets/svgs/profile-white.svg").default,
    activeIcon: require("../../assets/svgs/profile-white.svg").default,
  },
  // {
  //   id: 9,
  //   label: "Menu 8",
  //   url: "/terms-and-conditions",
  //   inactiveIcon: require("../../assets/svgs/terms-white.svg").default,
  //   activeIcon: require("../../assets/svgs/terms-white.svg").default,
  // },
  // {
  //   id: 10,
  //   label: "Menu 9",
  //   url: "/faqs",
  //   inactiveIcon: require("../../assets/svgs/faqs-white.svg").default,
  //   activeIcon: require("../../assets/svgs/faqs-white.svg").default,
  // },
];
